<template>
    <SeoHead :seo="seo" />
    <main-layout>
        <h1 class="visually-hidden">Волейбол Беларуси — календарь матчей</h1>
        <GamesCalendarSection
            :calendar="calendar"
            :teams="teams"
        />
    </main-layout>
</template>

<script setup>
import SeoHead from '@/Components/SeoHead.vue';
import MainLayout from '@/components/layout/MainLayout.vue';
import GamesCalendarSection from '@/components/features/calendar/GamesCalendarSection.vue';

defineProps({
    seo: {
        type: Object,
        default: null,
    },
    calendar: {
        type: Object,
        required: true,
    },
    teams: {
        type: Array,
        default: () => [],
    },
});
</script>
